import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { serviceApi } from '~/features';
import {
  SponsoredProductsCampaignExportDto,
  SponsoredProductsExportResponse,
} from '~/types';

async function downloadSponsoredProductsSimplifiedReportApi({
  IdAdvertiser,
  CampaignIds,
}: SponsoredProductsCampaignExportDto): Promise<SponsoredProductsExportResponse> {
  const params = {
    IdAdvertiser,
    CampaignIds,
  };

  const response: AxiosResponse<Blob> = await serviceApi
    .get(`/ReportProdutoPatrocinado/Campaigns-Export`, {
      params,
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    })
    .then(res => {
      return res;
    })
    .catch(error => {
      throw error;
    });

  return {
    data: response.data,
    headers: {
      'content-type':
        response.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': response.headers['content-disposition'],
    },
  };
}

async function downloadSponsoredProductsDetailedReportApi({
  IdAdvertiser,
  CampaignIds,
}: SponsoredProductsCampaignExportDto): Promise<SponsoredProductsExportResponse> {
  const params = {
    IdAdvertiser,
    CampaignIds,
  };

  const response: AxiosResponse<Blob> = await serviceApi
    .get(`/ReportProdutoPatrocinado/Export-Excel-Multiple-Campaigns`, {
      params,
      responseType: 'blob',
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    })
    .then(res => {
      return res;
    })
    .catch(error => {
      throw error;
    });

  return {
    data: response.data,
    headers: {
      'content-type':
        response.headers['content-type'] ||
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'content-disposition': response.headers['content-disposition'],
    },
  };
}

export function useDownloadSponsoredProductsSimplifiedReport(
  onSuccess?: (data: SponsoredProductsExportResponse) => void,
  onError?: (error: Error) => void
) {
  return useMutation({
    mutationFn: downloadSponsoredProductsSimplifiedReportApi,
    onSuccess,
    onError,
  });
}

export function useDownloadSponsoredProductsDetailedReport(
  onSuccess?: (data: SponsoredProductsExportResponse) => void,
  onError?: (error: Error) => void
) {
  return useMutation({
    mutationFn: downloadSponsoredProductsDetailedReportApi,
    onSuccess,
    onError,
  });
}
